import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, ButtonGroup, Row, Col, SelectPicker, Input, Panel } from 'rsuite'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { budgetFormat } from '../../utils/formatterUtil'
import { sessionGetItemObj, sessionRemoveItem, sessionSetItemStr } from '../../utils/sessionHelpers'

export default function SubProjectVoucherListTable({
  schema,
  loading,
  onDelete,
  onSelect,
  onSearch,
  onPreview,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [txtRecordTypeVal, setTxtRecordTypeVal] = useState('0')
  const [txtVoucherNumberVal, setTxtVoucherNumberVal] = useState('')
  const { periodNo, startAndEndDate } = sessionGetItemObj('subProjectPeriodInfo')

  useEffect(() => {
    setTableData(schema?.datas?.values || [])
  }, [schema])

  const createRequest = () => {
    return {
      recordType: txtRecordTypeVal,
      voucherNumber: txtVoucherNumberVal,
    }
  }

  const handleSearch = () => {
    const request = createRequest()

    onSearch(request)
  }

  const handleCancel = () => {
    setTxtRecordTypeVal('0')
    setTxtVoucherNumberVal('')

    onSearch({})
  }

  return (
    <>
      <Panel bordered header={'ค้นหา'} collapsible defaultExpanded>
        <div style={{ marginTop: -10, marginBottom: -10 }}>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.recordType.label}
              <SelectPicker
                searchable={false}
                value={txtRecordTypeVal}
                data={schema.recordType.options}
                block
                onChange={(value) => {
                  setTxtRecordTypeVal(value)
                }}
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.voucherNumber.label}
              <Input
                value={txtVoucherNumberVal}
                onChange={(value) => {
                  setTxtVoucherNumberVal(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <SearchButton disabled={false} onClick={handleSearch}>
                ค้นหา
              </SearchButton>
              {`  `}
              <CancelButton disabled={false} onClick={handleCancel}>
                ยกเลิก
              </CancelButton>
            </Col>
          </Row>
        </div>
      </Panel>

      <div style={{ marginTop: 20 }}>
        <Row>
          <Col lg={8} md={8} sm={24} xs={24}></Col>
          {schema?.isEnableEdit && schema?.isCanRefundSubProject && (
            <Col lg={16} md={16} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <SaveButton
                icon="plus-square"
                disabled={false}
                onClick={() => {
                  sessionRemoveItem('isViewOnly')
                  onSelect(null, 'Income')
                }}
                style={{
                  marginRight: 10,
                }}
              >
                เพิ่มบันทึกรับโครงการย่อย
              </SaveButton>
              <CancelButton
                icon="minus-square"
                disabled={false}
                onClick={() => {
                  sessionRemoveItem('isViewOnly')
                  onSelect(null, 'Outcome')
                }}
                style={{
                  marginRight: 10,
                }}
              >
                เพิ่มบันทึกจ่ายโครงการย่อย
              </CancelButton>
            </Col>
          )}
        </Row>
      </div>

      <Table
        wordWrap
        minHeight={350}
        autoHeight
        loading={loading}
        data={tableData}
        style={{ marginTop: 10 }}
      >
        <Column width={90} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={100} align="center">
          <HeaderCell>ประเภท</HeaderCell>
          <Cell>
            {(rowdata) => {
              if (rowdata.type === 'Income') {
                return <Icon icon="data-increase" style={{ color: 'green' }} />
              } else {
                return <Icon icon="data-decrease" style={{ color: 'red' }} />
              }
            }}
          </Cell>
        </Column>

        <Column width={250}>
          <HeaderCell>วันที่เอกสาร</HeaderCell>
          <Cell dataKey="documentDate" />
        </Column>

        <Column width={250}>
          <HeaderCell>เลขที่ใบสำคัญ</HeaderCell>
          <Cell dataKey="voucherNumber" />
        </Column>

        <Column width={350} minWidth={350} flexGrow={1}>
          <HeaderCell>คำอธิบาย</HeaderCell>
          <Cell dataKey="description" />
        </Column>

        <Column width={180}>
          <HeaderCell>จำนวนเงิน (บาท)</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.amount)
            }}
          </Cell>
        </Column>

        <Column width={150} align="center" fixed="right">
          <HeaderCell>จัดการรายการ</HeaderCell>
          <Cell>
            {(rowData) => {
              console.log('file ', rowData)
              // disabled={!rowData.pathFile} เช็คกรณีที่ pathFile = null
              return (
                <>
                  <ButtonGroup>
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-df"
                      size="sm"
                      icon={<Icon icon="eye" className="bt-gost-icon-none-radius" />}
                      onClick={(e) => {
                        sessionSetItemStr('isViewOnly', 'isViewOnly')
                        onSelect(rowData)
                      }}
                    ></IconButton>
                    {schema?.isEnableEdit && schema?.isCanRefundSubProject && (
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-edit"
                        size="sm"
                        icon={<Icon icon="edit" className="bt-gost-icon-none-radius-edit" />}
                        onClick={(e) => {
                          sessionRemoveItem('isViewOnly')
                          onSelect(rowData)
                        }}
                      ></IconButton>
                    )}
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-info"
                      size="sm"
                      icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
                      onClick={() => onPreview(rowData)}
                    ></IconButton>
                  </ButtonGroup>
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>
    </>
  )
}
